import React from "react";
import CustomTag from "./CustomTag";
import { FireOutlined } from "@ant-design/icons";
import FanDTO from "src/models/FanDTO";

interface BurnerStatusTagProps{

    fanState: FanDTO | null | undefined;

}

const BurnerStatusTag : React.FC<BurnerStatusTagProps> = ({ fanState }) => {

    if(fanState?.highFireOn === true || fanState?.lowFireOn === true){
        return(
            <CustomTag label={'Burner: ON'} icon={<FireOutlined />} color={"green"} />
        )
    }
    
    return(
        <CustomTag label={'Burner: OFF'} icon={<FireOutlined />} color={"red"} />
    )
}

export default BurnerStatusTag;